import React from 'react';

import InfoIcon from '../info-icon';
import {
  BannerAction,
  BannerBody,
  BannerHeader,
  BannerRoot,
  BannerRow,
  BannerTitle,
  OfferStatusSeverity,
  SEVERITY_COLORS,
} from './offer-status-banner.styled';

interface OfferStatusBannerProps {
  severity?: OfferStatusSeverity;
  title: React.ReactNode;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

const OfferStatusBanner: React.FC<OfferStatusBannerProps> = ({
  severity = 'info',
  title,
  children,
  action,
  className,
}) => (
  <BannerRoot $severity={severity} className={className}>
    <BannerHeader>
      <InfoIcon size={18} color={SEVERITY_COLORS[severity].icon} />
      <BannerTitle>{title}</BannerTitle>
    </BannerHeader>
    <BannerRow>
      <BannerBody as="div">{children}</BannerBody>
      {action && <BannerAction>{action}</BannerAction>}
    </BannerRow>
  </BannerRoot>
);

export default OfferStatusBanner;
